import { render, staticRenderFns } from "./full_screen.vue?vue&type=template&id=1f0a5947&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0a5947')) {
      api.createRecord('1f0a5947', component.options)
    } else {
      api.reload('1f0a5947', component.options)
    }
    module.hot.accept("./full_screen.vue?vue&type=template&id=1f0a5947&", function () {
      api.rerender('1f0a5947', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/full_screen.vue"
export default component.exports